﻿import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Circle from 'ol/geom/Circle.js';
import Feature from 'ol/Feature.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { PubTool };

/**
 * Class PubTool
 */
const PubTool = function () {

    // Define this
    var myPubTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Utility
    this._utility = new Utility();

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Feature to save
    this._featureInfo = null;

    // Geojson Format
    this._geojsonFormat = new GeoJSON();

    // -- end private variable ------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // feature colection use in road builder tool
    this.collectionFeatureSet = new Collection();

    // ocorrence id
    this.idOccurrence = 0;

    // ocorrence id
    this._ocorrenceDatatable = null;

    // ocorrence id
    this._ocorrenceDatatableData = [];

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Compare
     */
    this._Compare = function(a, b) {
        const posA = a.column_pos;
        const posB = b.column_pos;

        let comparison = 0;
        if (posA > posB) {
            comparison = 1;
        } else if (posA < posB) {
            comparison = -1;
        }

        return comparison;
    }

    /**
    * Get all references for pub tool
    */
    this._GetAllReferences = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/PubTool/GetAllReference',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myPubTool._hashReference['tipos_placar_mupi_list'] = data.result.list_tipos_placar_mupi;
                            myPubTool._hashReference['tipos_publicidade_list'] = data.result.list_tipos_publicidade;
                            myPubTool._hashReference['situacao_list'] = data.result.list_situacao;
                            myPubTool._hashReference['tipo_intervencao_list'] = data.result.list_tipo_intervencao;

                            myPubTool._utility.FillSelect('id-pubtoolType', data.result.list_tipos_publicidade, 'value', 'id', true);
                            myPubTool._utility.FillSelect('id-pubtoolSituacao', data.result.list_situacao, 'value', 'id', true);
                            myPubTool._utility.FillSelect('id-pubtoolTypePlacarMupi', data.result.list_tipos_placar_mupi, 'value', 'id', true);
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });

        myPubTool._hashReference['licenciado_list'] = [
            { "id": "0", "value": "Regularizado s/ Licença" },
            { "id": "1", "value": "Regularizado c/ Licença" },
            { "id": "2", "value": "Clandestino" }
        ];

        myPubTool._hashReference['freguesia_list'] = [];

        if (myPubTool._mapSgs._hashReference['freguesia'] === undefined) {
            myPubTool._mapSgs._GetAllReference();
        };

        myPubTool._utility.FillSelect('id-pubtoolLicenciado', myPubTool._hashReference['licenciado_list'], 'value', 'id', true);
    };

    /**
     * Save pub
     */
    this._SaveFeature = function (mode) {
        myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        let freguesiaValue = $("#prop_assoc_FREGUESIA option:selected").text();
        if (freguesiaValue == "Nenhum escolhido")
            freguesiaValue = "";

        let Id = $("#id-feature-edit").val();
        let idFreguesiaValue = $("#prop_FREGUESIA").val();
        let localValue = $("#prop_LOCAL_").val();
        let processoValue = $("#prop_ERPPROCESSO").val();
        let ordemValue = $("#prop_ERPORDEM").val();
        let tipoPublicidadeValue = $("#prop_ERPTIPOPUBLICIDADE").val();
        let requerenteValue = $("#prop_REQUERENTE").val();
        let idPubTipoPublicidadeValue = $("#prop_IDPUBTIPOPUBLICIDADE").val();
        let idPubSituacaoValue = $("#prop_IDPUBSITUACAO").val();
        let idLicenciado = $("#prop_LICENCIADO").val();
        let idPubTipoPlacarMupiValue = $("#prop_IDPUBTIPOPLACARMUPI").val();
        let descricaoValue = $("#prop_DESCRICAO").val();
        let observacoesValue = $("#prop_OBSERVACOES").val();
        let fotosValue = $("#prop_FOTOS").val();

        let geom_wkt = new WKT().writeGeometry(myPubTool._featureInfo.feature.getGeometry());
        let geom_srid = myPubTool._mapSgs._settings.projection.getCode().replace('EPSG:', '');

        let ocorrencias = myPubTool._hashReference['ocorrencias_list'];

        let panelSaveFields = {
            id: Id,
            freguesia: freguesiaValue,
            idFreguesia: idFreguesiaValue,
            local: localValue,
            processo: processoValue,
            ordem: ordemValue,
            tipoPublicidade: tipoPublicidadeValue,
            requerente: requerenteValue,
            idPubTipoPublicidade: idPubTipoPublicidadeValue,
            idPubSituacao: idPubSituacaoValue,
            idLicenciado: idLicenciado,
            idPubTipoPlacarMupi: idPubTipoPlacarMupiValue,
            descricao: descricaoValue,
            observacoes: observacoesValue,
            fotos: fotosValue,
            ocorrencias: ocorrencias,
            geom_wkt: geom_wkt,
            geom_srid: geom_srid
        };

        if (mode == 'update') {

            $.ajax({
                type: 'POST',
                url: '/rest/app/PubTool/EditPubPanel',
                async: true,
                data: JSON.stringify(panelSaveFields),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {

                    if (data.result.status == "SUCCESS") {

                        myPubTool._mapSgs.layerTree.CloseEdition(true);        

                        setTimeout(
                            function () {

                                var IdLayer = myPubTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName('PUBPAINEL');
                                for (let i = 0; i < IdLayer.length; i++) {

                                    var RefreshLayer = myPubTool._utility.GetLayerByName(app.sgs.Map.map, IdLayer[i].layerNameKey);
                                    RefreshLayer.getSource().clear();

                                }

                        }, 1000);

                        toastr["success"]("Painel de publicidade editado com sucesso");

                    } else {
                        toastr["error"]("Erro na gravação");
                    }

                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na gravação");
                }
            });

        } else {

            $.ajax({
                type: 'POST',
                url: '/rest/app/PubTool/CreatePubPanel',
                data: JSON.stringify(panelSaveFields),
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro na criação do painel de publicidade");
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':

                                myPubTool._mapSgs.layerTree.CloseEdition(true);    

                                setTimeout(
                                    function () {

                                        var IdLayer = myPubTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName('PUBPAINEL');
                                        for (let i = 0; i < IdLayer.length; i++) {

                                            var RefreshLayer = myPubTool._utility.GetLayerByName(app.sgs.Map.map, IdLayer[i].layerNameKey);
                                            RefreshLayer.getSource().clear();

                                        }

                                }, 1000);

                                toastr["success"]("Painel de publicidade criado com sucesso");

                                myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);

                                break;
                            default:
                                toastr["error"]("Erro na criação do painel de publicidade");
                                myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                        }
                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro na criação do painel de publicidade");
                    myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                }
            });
        }
    };

    /**
     * Get Freguesia Info from point
     */
    this._GetFreguesiaInfoFromPoint = function(featurePoint)
    {
        var featureReturn = null;

        // Get point geojson
        var pointCoord = null;
        if(featurePoint.getGeometry().getCoordinates()[0] instanceof Array)
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates()[0]);
        else
            pointCoord = turf.point(featurePoint.getGeometry().getCoordinates());

        myPubTool.collectionFeatureSet.getArray().forEach(function(featureIn, index)
        {
            if(featureIn.getId().indexOf("FREGUESIA") >= 0)
            {
                var featureInGeoJson = myPubTool._geojsonFormat.writeFeatureObject(featureIn);
                if(turf.booleanPointInPolygon(pointCoord, featureInGeoJson))
                {
                    // Get feature freguesia info
                    featureReturn =  featureIn;
                }
            }
        });
    
        return featureReturn;
    }

    /**
     * Search pub panel
     */
    this._SearchPanels = function () {
        myPubTool._utility.ShowWait('offcanvas-map-spinner', true);
								 
        // Build Filter
        var cqlFilter = "";
        var local = $('#id-pubtoolLocal').val();
        var freguesia = $('#id-pubtoolFreguesia').val();
        var type = $('#id-pubtoolType').val();
        var situacao = $('#id-pubtoolSituacao').val();
        var licenciado = $('#id-pubtoolLicenciado').val();
        var tipoPlacarMupi = $('#id-pubtoolTypePlacarMupi').val();

        if (local !== "") {
            var query = `LOCAL_ = '${local}'`;
            cqlFilter = query;
        }

        if (freguesia !== "") {
            var query = `IDFREGUESIA = ${freguesia}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (type !== "") {
            var query = `IDPUBTIPOPUBLICIDADE = ${type}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (situacao !== "") {
            var query = `IDPUBSITUACAO = ${situacao}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (licenciado !== "") {
            var query = `LICENCIADO = '${licenciado}'`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        if (tipoPlacarMupi !== "") {
            var query = `IDPUBTIPOPLACARMUPI = ${tipoPlacarMupi}`;

            if (cqlFilter === "") {
                cqlFilter = query;
            } else {
                cqlFilter = `${cqlFilter} AND ${query}`;
            }
        }

        // Get features
        var layerName = "PUBPAINEL";
        var layerInfo = this._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterResult = cqlFilter;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    if (myPubTool._mapSgs.featureToHighLight.getLength() > 0)
                        myPubTool._mapSgs.featureToHighLight.clear();

                    myPubTool._mapSgs._arraySearchLayerFeatureActive = [];

                    var feature = null;
                    var layerName = "PUBPAINEL"; //myPubTool._utility.GetPropertyInfoInConfigArray(myPubTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGN_TOOL", "LAYER_TRAFFIC_SIGN", "LAYER_NAME").value;
                    var idLayer = myPubTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                    var workspace = myPubTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                    var columnDefArray = [];
                    var columDefArrayExpand = [];
                    var columDefArrayExpandSize = [];
                    var columnValueArray = [];
                    var idPrimaryKey = null;
                    var featureHash = {};

                    for (let i = 0; i < data.features.length; i++) {
                        feature = (new GeoJSON()).readFeatures(data)[i];
                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myPubTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myPubTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myPubTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (i === 0) {
                                    var columnSearchResult = myPubTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myPubTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myPubTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myPubTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px',
                                            'search_order': searchResultOrder
                                        });
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myPubTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myPubTool._mapSgs._defaultHighlighStyles;
                        myPubTool._mapSgs.featureToHighLight.getArray()[myPubTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }

                    // Add primary key to array
                    columnDefArray.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    columDefArrayExpand.push({
                        'data': "id_primary_key",
                        'type': 'readonly',
                        'visible': false
                    });

                    // Add size to column in array expand
                    for (let i = 0; i < columDefArrayExpand.length; i++) {
                        var objDef = columDefArrayExpand[i];
                        if (objDef.width) {
                            if (columDefArrayExpandSize[objDef.data] > 50)
                                objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                            else
                                objDef.width = "50px";
                            columDefArrayExpand[i] = objDef;
                        }
                    };

                    // Show canvas search result
                    myPubTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                    // Make datatable list
                    myPubTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myPubTool.DetailElement);

                    // Go to Feature
                    myPubTool._mapSgs.map.getView().fit(myPubTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myPubTool._mapSgs.map.getSize() });

                    // Remove hide in offcanvas search result information
                    $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                    $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
                }
                else {
                    toastr["warning"]("Não foi encontrada, nenhuma camada");
                }
            };

            // Stop wait
            myPubTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    // -- end private method --------------------------------------------------------------------

    // -- begin public method --------------------------------------------------------------------

    /**
     * Fill hash freguesia
     * @param {array} freguesiasData, array of freguesia
     */
    this.FillFreguesiaList = function (freguesiasData) {
        freguesiasData.forEach(x => {
            myPubTool._hashReference['freguesia_list'].push({ "id": x.IDFREGUESIA, "value": x.FREGUESIA });
        });

        myPubTool._utility.FillSelect('id-pubtoolFreguesia', myPubTool._hashReference['freguesia_list'], 'value', 'id', true);
    };

    /**
     * Build detail information
     * @param {object} featureInfo, all information of the pub
     */
    this.DetailElement = function (featureInfo)
    {
        myPubTool._featureInfo = featureInfo;

        myPubTool._hashReference['ocorrencias_list'] = [];
        var codElement = "";

        // Start wait
        myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        // Clean Number of file
        $('.offcanvas-body-layer-detail-attachment-info-td span')[0].innerHTML = "-";

        // Define according to mode
        var readOnly = "readonly";
        var hiddenCol = false;
        switch (featureInfo.mode) {
            case 'update':
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').off('click').on('click', function () {
                    //myPubTool._mapSgs._SaveFeature('update', app.Select.getFeatures().getArray()[0]);
                    myPubTool._SaveFeature('update');
                });
                readOnly = "";
                break;
            case 'create':
                $('#id-offcanvas-body-layer-detail-button').removeClass('ol-hidden');
                $('#id-save-feature-submit').off('click').on('click', function () {
                    myPubTool._SaveFeature('insert');
                });
                readOnly = "";
                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-button').addClass('ol-hidden');
        }

        // Show canvas
        myPubTool._utility.ShowOpenCanvas3('id-offcanvas-layer-detail', true);

        // Layer info
        var layerObj = myPubTool._mapSgs.layerTree.layerInfo.dict_layer_info[featureInfo.idLayer];
        var layerName = layerObj.layer_info.layerName;
        var layerPrettyName = layerObj.layer_info.pretty_name;

        // Get codElement
        if (featureInfo.feature.getProperties().import_code)
            codElement = featureInfo.feature.getProperties().import_code;

        // Build title
        $('#id-offcanvas-head-title-element')[0].innerHTML = layerObj.layer_info.pretty_name;
        $('#id-offcanvas-head-code-element')[0].innerHTML = codElement;

        $('#id-open-saga').remove();

        // -- Fields -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-detail-field').empty();

        var gpName = myPubTool._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy;

        layerObj.list_column.sort(myPubTool._Compare);

        if (featureInfo.mode == 'update') {

            $('#id-offcanvas-body-layer-detail-field').append(
                '<input id="id-feature-edit" value="' + featureInfo.feature.values_.ID + '" hidden />'
            );

        }

        // Build Info field
        for (var i = 0; i < layerObj.list_column.length; i++)
        {
            var objColumn = layerObj.list_column[i];

            // Show only if field marked as visible
            if (!objColumn.visible) continue;

            // Show only if field marked as editable for creations
            if (!objColumn.editable && featureInfo.mode == 'create') continue; 

            if (objColumn.editable && (featureInfo.mode == 'update' || featureInfo.mode == 'create')) {
                readOnly = '';
                if (featureInfo.mode == 'update' && (objColumn.column_name == 'zone' || objColumn.column_name == 'id_zone')) {
                    readOnly = 'readonly'; // Cannot update zone in model (Update DB procedures to change this)
                }
            } else {
                readOnly = 'readonly';
            }

            if (layerObj.list_column[i].column_pos == 1) {
                $('#id-offcanvas-body-layer-detail-field').append(
                    '<div style="border-bottom: lightgray; border-bottom-style: solid"><span style="font-size: 12px;">Localização</span></div>'
                );
            } else if (layerObj.list_column[i].column_pos == 3) {
                $('#id-offcanvas-body-layer-detail-field').append(
                    '<div style="border-bottom: lightgray; border-bottom-style: solid"><span style="font-size: 12px;">Processo</span></div>'
                    + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-processes-btn-associate-new-process" style="margin: 5px 0;">Associar Novo Processo</button>'
                );
            }

            if (objColumn.column_name === 'FOTOS') {
                //$('#id-offcanvas-body-layer-detail-field').append($(
                //    '<div style="border-bottom: lightgray; border-bottom-style: solid"' + (hiddenCol ? ' hidden' : '') + '><span style="font-size: 12px;">Foto</span></div>'
                //    + '<div class="custom-file' + (hiddenCol ? ' hidden' : '') + '">'
                //    + '<input class="custom-file-input ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" style="display:block; margin-top: 5px;" type="file" id="prop_' + objColumn.column_name + '"' + readOnly + '/>'
                //    + '</div > '
                //));
                continue;
            }

            // Change condition according to GP to not include ID fields (myTooltips._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA')
            //if (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 2).toUpperCase() !== 'ID') {
            if ((objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ' && objColumn.column_name.substr(0, 6).toUpperCase() === 'ID_REF')
                || (objColumn.column_name !== 'geom' && objColumn.column_name !== 'GEOMETRY ')) {

                let value = featureInfo.feature.getProperties()[objColumn.column_name];

                let isRefCol = false;
                let codUniverseTable = "";

                switch (objColumn.column_name) {
                    case "IDFREGUESIA":
                        isRefCol = true;
                        codUniverseTable = "freguesia_list";
                        break;
                    case "LICENCIADO":
                        isRefCol = true;
                        codUniverseTable = "licenciado_list";
                        break;
                    case "IDPUBTIPOPLACARMUPI":
                        isRefCol = true;
                        codUniverseTable = "tipos_placar_mupi_list";
                        break;
                    case "IDPUBTIPOPUBLICIDADE":
                        isRefCol = true;
                        codUniverseTable = "tipos_publicidade_list";
                        break;
                    case "IDPUBSITUACAO":
                        isRefCol = true;
                        codUniverseTable = "situacao_list";
                        break;
                    default:
                        break;
                };

                if (gpName == 'GP_PONTA_DELGADA' && objColumn.column_name == 'DATA') {
                    hiddenCol = true; // Hide column DATA for PONTA DELGADA creations
                    value = myPubTool._utility.getNewDateForServer();
                } else {
                    hiddenCol = false;
                }
                if (value === null || value === undefined)
                    value = '';
                // Act according column type
                switch (objColumn.column_type) {
                    case "xsd:date-time":
                        value = myPubTool._utility.TransformDateServerInDateII(value);
                        break;
                    default:
                    // do nothing
                }

                var comboArray = [];
                var prefix = "id_";
                if (isRefCol) {
                    comboArray = myPubTool._hashReference[codUniverseTable];
                    prefix = "";
                }

                // Check if there is an associated field with a id_ prefix to add combo boxes
                if (isRefCol) {
                    var defValue = "";

                    if (objColumn.column_name == "LICENCIADO") {
                        value = layerPrettyName
                    }

                    if (value != "") {
                        if(comboArray.length > 0)
                        {
                            if (objColumn.column_name == "LICENCIADO") {
                                defValue = comboArray.filter(function (ob) { return ob.value == value; })[0]
                            } else {
                                defValue = comboArray.filter(function (ob) { return ob.id == value; })[0]
                            }

                            if (featureInfo.mode == 'read') {
                                defValue = defValue.value;
                            } else {
                                defValue = defValue.id;
                            }
                        }
                    }

                    // Fill rule for field
                    switch(objColumn.column_name) {
                        case "IDFREGUESIA":
                            var featureFreguesia = myPubTool._GetFreguesiaInfoFromPoint(myPubTool._featureInfo.feature);
                            if(featureFreguesia !== null)
                                defValue = featureFreguesia.getProperties().IDFREGUESIA;
                            break;
                        default:
                            break;
                    }

                    // In read mode, add text box for ID_REF
                    if (featureInfo.mode == 'read') {

                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));

                    } else {

                        var disabled = readOnly == 'readonly' ? 'disabled' : '';
                        // Add select box with associated entity possible values
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<select title="Nenhum escolhido" class="feature-field form-control ' + objColumn.column_type + '" id="prop_assoc_' + objColumn.column_name + '" data-name= "' + objColumn.column_name + '" data-destination-field="prop_' + prefix + objColumn.column_name + '" ' + disabled + '><option></option></select>'
                            + '</div > '
                        ));

                        myPubTool._utility.FillSelect("prop_assoc_" + objColumn.column_name, comboArray, 'value', 'id');

                        $('#' + 'prop_assoc_' + objColumn.column_name).selectpicker('val', defValue);

                        // Add field that contains ID for associated entity
                        $('#id-offcanvas-body-layer-detail-field').append($(
                            '<div class="form-group offcanvas-body-layer-detail-row hidden">'
                            + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                            + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + prefix + objColumn.column_name + '" type="text" id="prop_' + prefix + objColumn.column_name + '" value="' + defValue + '" ' + readOnly + '/>'
                            + '</div > '
                        ));
                    }
                } else {
                    $('#id-offcanvas-body-layer-detail-field').append($(
                        '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + '">'
                        + '<label for="prop_' + objColumn.column_name + '">' + objColumn.pretty_name + '</label>'
                        + '<input class=" feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="text" id="prop_' + objColumn.column_name + '" value="' + value + '" ' + readOnly + '/>'
                        + '</div > '
                    ));
                }
            }
        };

        let container = $("#id-offcanvas-layer-detail .mCSB_container");

        // -- Ocorrências -------------------------------------------------------------------------------
        $('#id-offcanvas-body-occurrence').remove();

        //let occurrencesContent = '<div id="id-offcanvas-body-layer-detail-occurrences" class="offcanvas-block" style="display: none;">'
        //    + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao" style="margin-bottom: 5px;">Inserir Intervenção</button>'
        //    + '<div id="prop_ocorrencia_add_ocorrencia_div" class="form-group offcanvas-body-layer-detail-row hidden">'
        //    + '<label for="prop_ocorrencia_add_ocorrencia">Ocorrência</label>'
        //    + '<input class="feature-field form-control xsd:string" id="prop_ocorrencia_add_ocorrencia" value="">'
        //    + '</div>'
        //    + '<div id="prop_ocorrencia_add_tipo_div" class="form-group offcanvas-body-layer-detail-row hidden">'
        //    + '<label for="prop_ocorrencia_add_tipo">Tipo</label>'
        //    + '<select title="Nenhum escolhido" class="feature-field form-control xsd:string" id="prop_ocorrencia_add_tipo"><option></option></select>'
        //    + '</div>'
        //    + '<div id="prop_ocorrencia_add_data_div" class="form-group offcanvas-body-layer-detail-row hidden">'
        //    + '<label for="prop_ocorrencia_add_data">Data</label>'
        //    + '<input class="feature-field form-control xsd:string" id="prop_ocorrencia_add_data" type="date" value="">'
        //    + '</div>'
        //    + '<div id="prop_ocorrencia_add_buttons_div" class="form-group offcanvas-body-layer-detail-row hidden">'
        //    + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao-close" style="margin: 0 2px;">Fechar</button>'
        //    + '<button type="button" class="btn btn-primary" id="id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao-add" style="margin: 0 2px;">Inserir</button>'
        //    + '</div>'
        //    + '<div class="table-responsive">'
        //    + '<table id="id-intervencao-table" class="table" table-hover>'
        //    + '<thead><tr><th scope="col">Ocorrência</th><th scope="col">Tipo</th><th scope="col">Data</th></tr></thead>'
        //    + '<tbody id="id-offcanvas-body-layer-detail-occurrences-table-body">'
        //    + '</tbody>'
        //    + '</table>'
        //    + '</div>'
        //    + '</div>';

        //container.append('<div id="id-offcanvas-body-layer-occurrences" class="row margin-top-lg offcanvas-body-layer-detail">'
        //    + '<div class="col-md-12">'
        //    + '<div>'
        //    + '<div target-id="id-offcanvas-body-layer-detail-occurrences" class="offcanvas-collapse">'
        //    + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
        //    + '<label>Ocorrências</label>'
        //    + '</div>'
        //    + occurrencesContent
        //    + '</div>'
        //    + '<div class="offcanvas-separator"></div>'
        //    + '</div>'
        //    + '</div>');

        var buttonInter;

        if (featureInfo.feature.getId() != null) {

            buttonInter = '<a id="id-offcanvas-body-add-occurrence-pub" class="offcanvas-body-layer-deposition-point-new-element-btn" title="Novo Produtor" id-pub-point="' + featureInfo.feature.getId().split('.')[1] + '"><i class="fa fa-plus-square"></i></a>';

        
        
            let occurrencesContent = '<div id="id-offcanvas-body-layer-detail-produtores" class="offcanvas-block" style="display: none;">'
                + buttonInter
                + '<div class="table-responsive">'
                + '<div id="id-producer-table-container" class="body table-responsive">'
                + '<table id="id-ocorrence-pub-table" class="table table-striped table-bordered table-hover table-deposition-point" width="100%"></table>'
                + '</div>'
                + '</div>'
                + '</div>';

            container.append('<div id="id-offcanvas-body-occurrence" class="row margin-top-lg offcanvas-body-layer-detail">'
                + '<div class="col-md-12">'
                + '<div>'
                + '<div target-id="id-offcanvas-body-layer-detail-produtores" class="offcanvas-collapse">'
                + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
                + '<label>Ocorrências</label>'
                + '</div>'
                + occurrencesContent
                + '</div>'
                + '<div class="offcanvas-separator"></div>'
                + '</div>'
                + '</div>');

            // -- init column def --
            var columnDefArrayOcorrence = [];

            // Definition column of equipment intervention
            columnDefArrayOcorrence.push({
                'name': 'button_config_element',
                'data': null,
                'orderable': false,
                'className': 'dt-body-center',
                'defaultContent': '<a class="button-detail-ocurrence-pub" title="Editar a intervenção"><i class="fa fa-edit" style="color: #ff3d00"></i></a>',
                'width': '3%'
            });
            columnDefArrayOcorrence.push({
                'name': 'button_config_element',
                'data': null,
                'orderable': false,
                'className': 'dt-body-center',
                'defaultContent': '<a class="button-remove-ocurrence-pub" title="Remover a intervenção"><i class="fa fa-trash-o" style="color: #ff3d00"></i></a>',
                'width': '3%'
            });
            columnDefArrayOcorrence.push({
                'data': "IdOccurrencePub",
                'type': 'readonly',
                'visible': false
            });
            columnDefArrayOcorrence.push({
                'data': 'Occurrence',
                'title': 'Nome',
                'name': 'Nome',
                'label': 'Nome',
                'type': 'readonly',
                'orderable': false,
                'width': '50px'
            });
            columnDefArrayOcorrence.push({
                'data': 'dt_process',
                'title': 'Data',
                'name': 'Data',
                'label': 'Data',
                'type': 'readonly',
                'orderable': false,
                'width': '50px'
            });


            // Build equipment intervation deposition point table
            myPubTool._ocorrenceDatatable = $('#id-ocorrence-pub-table').DataTable({
                "dom": '<rtip',
                "destroy": true,
                "language": {
                    "emptyTable": 'Nenhum elemento'
                },
                "fixedHeader": true,
                "info": false,
                "scrollCollapse": false,
                "deferRender": false,
                "scroller": false,
                "paging": false,
                "ordering": false,
                "columns": columnDefArrayOcorrence,
                "select": false,
                "name": "deposition_point_observation_table",
                "rowId": 'IdOccurrencePub',
                "initComplete": function (settings, json) {

                    $.ajax({
                        type: 'GET',
                        url: '/rest/app/PubTool/GetOccurrencePub?Id_Pub=' + parseInt($('#id-offcanvas-body-add-occurrence-pub').attr('id-pub-point')),
                        async: true,
                        dataType: 'json',
                        contentType: "application/json",
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção das observações");
                            }
                            else {
                                if (data.result.length > 0){
                                    var listOccurrence = data.result.pub_panel_occurrence;
                                    if (listOccurrence.length > 0) {

                                        myPubTool._ocorrenceDatatable.clear();

                                        myPubTool._ocorrenceDatatableData = data.result;

                                        for (let i = 0; i < listOccurrence.length; i++) {
                                            myPubTool._ocorrenceDatatable.row.add({
                                                IdOccurrencePub: listOccurrence[i].objectid,
                                                Occurrence: listOccurrence[i].pubpainelintervencao,
                                                dt_process: myPubTool._utility.TransformDateServerInDateII(listOccurrence[i].dataintervencao),
                                            });
                                        }
                                        myPubTool._ocorrenceDatatable.draw();
                                    }
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção das observações");
                        }
                    });
                }
            });

            // Event on draw table
            myPubTool._ocorrenceDatatable.on('draw', function () {

                // Open detail equipment intervention
                $('.button-detail-ocurrence-pub').off('click').on('click', function () {

                    var DataRow = myPubTool._ocorrenceDatatableData.filter(c => c.objectid == this.closest('tr').id);

                    $('#id-modal-create-occurrence-pub-description').val(DataRow[0].pubpainelintervencao);

                    if (DataRow[0].idpubtipointervencao) {
                        $('#id-search-toponymy-place').val(DataRow[0].idpubtipointervencao).trigger("change");
                    }

                    $('#id-date-occurrence-pub').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

                    $('#id-date-occurrence-pub').val(myPubTool._utility.TransformDateServerInDateII(DataRow[0].dataintervencao));

                    $('#id-modal-create-occurrence-pub').modal('show');

                });

                // Open remove observaton from deposition point
                $('.button-remove-ocurrence-pub').off('click').on('click', function () {

                    $.ajax({
                        type: 'DELETE',
                        url: '/rest/app/PubTool/DeleteOccurrencePub?Id_Pub=' + this.closest('tr').id,
                        async: true,
                        dataType: 'json',
                        contentType: "application/json",
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na obtenção das observações");
                            }
                            else {
                                if (data.result.length > 0) {
                                    var listOccurrence = data.result;
                                    if (listOccurrence.length > 0) {

                                        myPubTool._ocorrenceDatatable.clear();

                                        myPubTool._ocorrenceDatatableData = data.result;

                                        for (let i = 0; i < listOccurrence.length; i++) {
                                            myPubTool._ocorrenceDatatable.row.add({
                                                IdOccurrencePub: listOccurrence[i].objectid,
                                                Occurrence: listOccurrence[i].pubpainelintervencao,
                                                dt_process: myPubTool._utility.TransformDateServerInDateII(listOccurrence[i].dataintervencao),
                                            });
                                        }
                                        myPubTool._ocorrenceDatatable.draw();
                                    }
                                }
                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na obtenção das observações");
                        }
                    });

                });

            });

            // New equipment producer add
            $('#id-offcanvas-body-add-occurrence-pub').off('click').on('click', function () {

                $('#id-modal-create-occurrence-pub-description').val(null);

                $('#id-date-occurrence-pub').val(null);

                $('#id-modal-create-occurrence-pub-type').val(null).trigger('change');

                $('#id-date-occurrence-pub').datepicker({ uiLibrary: 'bootstrap', format: 'yyyy-mm-dd' });

                // Open Modal
                $('#id-modal-create-occurrence-pub').modal('show');


            });

            // New equipment producer add
            $('#id-modal-create-new-occurrence-pub').off('click').on('click', function () {

                // Close Modal
                $('#id-modal-create-occurrence-pub').modal('hide');

                var formData = $('#id-modal-create-occurrence-pub-body-form').serializeJSON();

                formData.Id_Pub = parseInt($('#id-offcanvas-body-add-occurrence-pub').attr('id-pub-point'));

                $.ajax({
                    type: 'POST',
                    url: '/rest/app/PubTool/CreateOccurrencePub',
                    data: JSON.stringify(formData),
                    async: true,
                    dataType: 'json',
                    contentType: "application/json",
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na obtenção das observações");
                        }
                        else {
                            if (data.result.length > 0) {
                                var listOccurrence = data.result;
                                if (listOccurrence.length > 0) {

                                    myPubTool._ocorrenceDatatable.clear();

                                    myPubTool._ocorrenceDatatableData = data.result;

                                    for (let i = 0; i < listOccurrence.length; i++) {
                                        myPubTool._ocorrenceDatatable.row.add({
                                            IdOccurrencePub: listOccurrence[i].objectid,
                                            Occurrence: listOccurrence[i].pubpainelintervencao,
                                            dt_process: myPubTool._utility.TransformDateServerInDateII(listOccurrence[i].dataintervencao),
                                        });
                                    }
                                    myPubTool._ocorrenceDatatable.draw();
                                }
                            }
                        }
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na obtenção das observações");
                    }
                 });

            });

            myPubTool._utility.FillSelect("prop_ocorrencia_add_tipo", myPubTool._hashReference['tipo_intervencao_list'], 'value', 'id');

        }

        // Add Intervenção click
        $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao').off('click').on('click', function () {
            $("#prop_ocorrencia_add_ocorrencia_div").removeClass("hidden");
            $("#prop_ocorrencia_add_tipo_div").removeClass("hidden");
            $("#prop_ocorrencia_add_data_div").removeClass("hidden");
            $("#prop_ocorrencia_add_buttons_div").removeClass("hidden");
        });

        // Close Add Intervenção click
        $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao-close').off('click').on('click', function () {
            $("#prop_ocorrencia_add_ocorrencia_div").addClass("hidden");
            $("#prop_ocorrencia_add_ocorrencia").val("")
            $("#prop_ocorrencia_add_tipo_div").addClass("hidden");
            $("#prop_ocorrencia_add_tipo").val("")
            $("#prop_ocorrencia_add_data_div").addClass("hidden");
            $("#prop_ocorrencia_add_data").val("")
            $("#prop_ocorrencia_add_buttons_div").addClass("hidden");
        });

        // Confirm Add Intervenção click
        $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao-add').off('click').on('click', function () {
            let ocorrenciaValue = $("#prop_ocorrencia_add_ocorrencia").val();
            let tipoValue = $("#prop_ocorrencia_add_tipo option:selected").text();
            let tipoId = $("#prop_ocorrencia_add_tipo").val();
            let dataValue = $("#prop_ocorrencia_add_data").val();

            let dataValues = dataValue.split('-');
            dataValue = `${dataValues[2]}/${dataValues[1]}/${dataValues[0]}`;

            if (tipoValue == "Nenhum escolhido")
                tipoValue = "";

            let newContent = `<tr><td>${ocorrenciaValue}</td><td>${tipoValue}</td><td class="hidden">${tipoId}</td><td>${dataValue}</td></tr>`;

            myPubTool._hashReference['ocorrencias_list'].push({"ocorrencia": ocorrenciaValue, "tipo": tipoId, "data": dataValue});

            let tableBody = $("#id-offcanvas-body-layer-detail-occurrences-table-body");
            tableBody.append(newContent);

            $("#prop_ocorrencia_add_ocorrencia_div").addClass("hidden");
            $("#prop_ocorrencia_add_ocorrencia").val("")
            $("#prop_ocorrencia_add_tipo_div").addClass("hidden");
            $("#prop_ocorrencia_add_tipo").val("")
            $("#prop_ocorrencia_add_data_div").addClass("hidden");
            $("#prop_ocorrencia_add_data").val("")
            $("#prop_ocorrencia_add_buttons_div").addClass("hidden");
        });

        // -- Licenças -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-licenses').remove();

        let licensesContent = '<div id="id-offcanvas-body-layer-detail-licenses" class="offcanvas-block" style="display: none;">'
            + '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_LICENCA">Licença</label>'
            + '<input class="sfeature-field form-control xsd:string" data-name="LICENCA" type="text" id="prop_LICENCA" value="">'
            + '</div>'
            + '</div>';

        container.append('<div id="id-offcanvas-body-layer-licenses" class="row margin-top-lg offcanvas-body-layer-detail">'
            + '<div class="col-md-12">'
            + '<div>'
            + '<div target-id="id-offcanvas-body-layer-detail-licenses" class="offcanvas-collapse">'
            + '<i class="fa option-title-go-right-open fa-chevron-down"></i>'
            + '<label>Licenças</label>'
            + '</div>'
            + licensesContent
            + '</div>'
            + '<div class="offcanvas-separator"></div>'
            + '</div>'
            + '</div>');

        // -- SAGA button ---------------------------------------------------------------------------
        let saveButtonDiv = $(".offcanvas-body-layer-detail-button-save");

        saveButtonDiv.append('<button type="button" class="btn btn-primary" id="id-open-saga" style="margin-left: 5px;">Abrir no SAGA</button>');

        // Open SAGA click
        $('#id-open-saga').off('click').on('click', function () {
            
        });

        // Associate New Process click
        $('#id-offcanvas-body-layer-detail-processes-btn-associate-new-process').off('click').on('click', function () {
            
        });

        // Add values and behaviours to combo boxes
        $('select.feature-field').each(function () {
            var comboBox = $(this);
            var destinationText = comboBox.data('destination-field');
            comboBox.on('change', function () {
                // Update respective id field for db update
                $('#' + destinationText).val($(this).val());
            });
        });

        // Refresh collapse elements
        $('.offcanvas-collapse').off('click').on('click', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // -- File --------------------------------------------------------------------------------

        // Init Upload for entity
        if (myPubTool._mapSgs._uploadAttachtment)
            myPubTool._mapSgs._uploadAttachtment.LoadAttachment(featureInfo.id, layerName, 'id-offcanvas-body-layer-detail-attachment-zone', 'id-offcanvas-body-layer-detail-attachment-form', 'id-offcanvas-body-layer-detail-attachment-add', 'offcanvas-body-layer-detail-attachment-info-td', 'id-offcanvas-body-layer-detail-attachment-spinner');

        // -- occurence --
        switch (featureInfo.mode) {
            case 'update':
                $('#id-offcanvas-body-layer-detail-processes-btn-associate-new-process').css({ display: "block" });
                $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao').css({ display: "block" });
                break;
            case 'create':
                $('#id-offcanvas-body-layer-detail-processes-btn-associate-new-process').css({ display: "block" });
                $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao').css({ display: "block" });
                break;
            default: // read
                $('#id-offcanvas-body-layer-detail-processes-btn-associate-new-process').css({ display: "none" });
                $('#id-offcanvas-body-layer-detail-occurrences-btn-add-intervencao').css({ display: "none" });
        }

        // Stop wait
        myPubTool._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
    };

    /**
     * Clean detail
     */
    this.CleanDetail = function ()
    {
        // -- Ocorrências -------------------------------------------------------------------------------
        $('#id-offcanvas-body-occurrence').remove();
        // -- Licenças -------------------------------------------------------------------------------
        $('#id-offcanvas-body-layer-licenses').remove();
    }

    // -- end public method --------------------------------------------------------------------

    // -- begin event --------------------------------------------------------------------------

    $('#id-buttonsearchPubTool').on('click', function () {
        myPubTool._SearchPanels();
    });

    // -- end event ----------------------------------------------------------------------------

};

/**
 * Init pub tool
 * @param {object} mapSgs, map object
 */
PubTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // -- Get all references -----------------------------------------------------------------
        this._GetAllReferences();
    }
};